module.exports = __webpack_public_path__ + "static/img/egg_g_04.4ae915b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/eggs/g/egg_g_04.png
// module id = mS7N
// module chunks = 1